import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { selectQuotationInsulatedBoxAccessories } from "app/containers/WorkOrder/redux/selector";
import { actions } from "app/containers/WorkOrder/redux/slice";
import { PlusIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { useStyles } from "../styles";
import { insulatedKey } from "./BoxStructureCards";

const cellValue = (value: string, t: (key: string) => string) =>
  value.startsWith("QUOTES.") ? t(value) : value;

const STRIP_COLUMNS = { gridTemplateColumns: "48px 1fr 1fr 2fr" };

const AccessoriesTable = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const { tyingStrips } = useSelector(selectQuotationInsulatedBoxAccessories);

  return (
    <Box className={styles.tableBlock}>
      <Box className={styles.tableHeaderRow}>
        <Typography className={styles.tableTitle}>
          {t(insulatedKey("SECTIONS.TYING_STRIP"))}
        </Typography>
        <Button
          className={styles.addRowButton}
          variant="contained"
          color="primary"
          startIcon={<PlusIcon width={20} height={20} />}
          onClick={() =>
            dispatch(actions.addQuotationInsulatedBoxTyingStripRow())
          }
        >
          {t(insulatedKey("TABLES.ADD_ROW"))}
        </Button>
      </Box>
      <Box className={styles.table}>
        <Box className={styles.tableHeadRowBasket} sx={STRIP_COLUMNS}>
          <Typography className={styles.tableHeadCell}>#</Typography>
          <Typography className={styles.tableHeadCell}>
            {t(insulatedKey("FIELDS.HEIGHT"))}
          </Typography>
          <Typography className={styles.tableHeadCell}>
            {t(insulatedKey("FIELDS.LOCATION"))}
          </Typography>
          <Typography className={styles.tableHeadCell}>
            {t(insulatedKey("FIELDS.NOTE"))}
          </Typography>
        </Box>
        {tyingStrips.map((row, index) => (
          <Box
            key={row.id}
            className={styles.tableBodyRowBasket}
            sx={STRIP_COLUMNS}
          >
            <Box className={`${styles.tableCell} ${styles.tableIndexCell}`}>
              {index + 1}
            </Box>
            <Box className={styles.tableCell}>
              <Typography className={styles.tableCellText}>
                {cellValue(row.height, t)}
              </Typography>
            </Box>
            <Box className={styles.tableCell}>
              <Typography className={styles.tableCellText}>
                {cellValue(row.location, t)}
              </Typography>
            </Box>
            <Box className={styles.tableCell}>
              <Typography className={styles.tableCellText}>
                {cellValue(row.note, t)}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AccessoriesTable;
